import router from "@/router";
import {auth_api} from "@/axios";
import {useToast} from "vue-toastification";

const toast = useToast();

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

const local_storage_token_key = 'auth_token';

const state = () => ({
    token: null,
    data: null,
    change_password_token: null,
    show_timeout_warning: false
})

const getters = {}

const actions = {
    async init(context) {
        let token = localStorage.getItem(local_storage_token_key);

        if (token)
            await context.dispatch('refresh_token_and_timeouts', token);

        if (context.state.token) {
            context.dispatch('refresh');
        }

        return Promise.resolve();
    },
    login(context, credentials) {
        auth_api.post("/api/user/login", credentials)
            .then(async () => {
                router.push({name: 'service_monitoring'});
            })
            .catch(err => {
                switch (err.response.data.result) {
                    case 'password_expired':
                        setTimeout(() => context.commit('set_change_password_token', err.response.data.stateToken), 2000);
                        break;
                }
            });
    },
    refresh(context) {
        auth_api.get("/api/user/login_refresh")
            .then(() => {

            })
            .catch(err => {
                switch (err.response.data.result) {
                    case 'password_expired':
                        toast.warning('Password Expired!');
                        setTimeout(() => this.$router.push(`/change_password/${err.response.data.stateToken}`), 2000);
                        break;
                    case 'unauthorized':
                        toast.error("Username/Password not Recognized");
                        break;
                    default:
                        toast.error("Error not recognized.  Contact rick.gentry@crispin.com");
                        break;
                }
            });
    },
    refresh_token_and_timeouts(context, token) {
        if (!token) {
            if (router.currentRoute.value.name !== 'home') {
                const current_path = router.currentRoute.value.path;
                const route = {name: 'home'}
                if (current_path !== '/') {
                    route.query = {path: current_path}
                }
                router.replace(route);
            }
            return;
        }
        context.commit('set_token', token);


        let logout_timeout = null;
        let logout_warning_timeout = null;
    },
    logout(context, {preserve_path = false} = {}) {
        context.commit('set_token', null);

        const route = {name: 'home'};
        const current_path = router.currentRoute.value.path;
        if (current_path && preserve_path) {
            route.query = {path: current_path}
        }
        auth_api.post("/api/user/logout")
            .then(() => router.push(route))
            .catch(() => router.push(route));
    }
}

const mutations = {
    set_token(state, token) {
        if (token) {
            localStorage.setItem(local_storage_token_key, token);
            state.token = token;
            state.data = token && parseJwt(token);
        } else {
            localStorage.removeItem(local_storage_token_key);
            state.token = null;
            state.data = null;
        }
    },
    set_change_password_token(state, change_password_token) {
        state.change_password_token = change_password_token;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}